import React, { Component } from 'react';
import MalidCard from './MalidCard';

class BlondalView extends Component {
	render() {
		return (
			<MalidCard title={window.l('blondal_title')}
				subTitle={window.l('blondal_subtitle')}
				count={this.props.count}
				visible={(this.props.data && this.props.data.length > 0)}
				frontPage={this.props.frontPage}
				database="blondal"
				aboutText={window.l('blondal_about')}
				className="truncated">
				{
					this.props.data && this.props.data.map(function(item, index) {

						return <React.Fragment key={index}>
							{
								index > 0 && <hr className="divider"/>
							}
							<p className={'card-text'+(item.fletta.length > 1000 ? ' preview' : '')}>
								<em>{item.bok}</em>
								<br/><br/>
								<span className="font-andron" dangerouslySetInnerHTML={{__html: item.fletta}} />
							</p>
							<p className="card-text"><a target='blank' className="text-light" href={'https://blondal.arnastofnun.is/faersla/'+item.id}>Sjá færslu í orðabók</a></p>
						</React.Fragment>
					})
				}
			</MalidCard>
		);
	}
}

export default BlondalView;



// WEBPACK FOOTER //
// ./src/components/BlondalView.js